import type { ActivityModule } from '../../core/activity';
import { mountReverseCount } from './ui';
import levelsData from './levels.json';
import './style.css';

export const reverseCount: ActivityModule = {
  id: 'reversecount',
  title: 'Conte os blocos',
  description: 'Ajude o pinguim a alcançar o peixe. Monte o número de blocos no dominó.',
  ageMin: 4,
  ageMax: 7,
  difficulty: 2,
  iconPath: 'assets/gcompris-AGPL/reversecount/icon.svg',
  category: 'numeracao',
  totalLevels: levelsData.levels.length,
  mount: mountReverseCount,
};
